// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__2CJMz","content":"PrivacyPolicyPage_content__1bY94"};